import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import LogoStyles from '../styles/LogoStyles';

function Logo() {
  return (
    <LogoStyles to="/">
      <StaticImage 
        src="../images/sisizathuhub.jpg" 
        height={50} /* Only restrict the height, let Gatsby calculate the natural width! */
        alt="Sisizathu Hub Logo"
        objectFit="contain"
      />
    </LogoStyles>
  );
}

export default Logo;